import { Box, Button, MenuItem, Typography, Autocomplete } from "@mui/material";
import { useEffect, useState } from "react";
import Grid from '@mui/material/Grid';
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import styles from '../../../styles.module.css';
import { Breadcrumb, Cancel, CTSinput } from "../../reusableComponent/Reusables";
import SaveIcon from '@mui/icons-material/Save';
import dayjs from "dayjs";
import userMasterService from "../../../services/masters/userMaster.Service";
import plantMasterService from "../../../services/masters/plantMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const UserAdd = () => {
  const { handleSubmit, control, formState: { errors }, setValue, watch } = useForm({
    defaultValues: {
      user_name: '',
      user_role_id: '',
      location_type: '',
      depot_id: '',
      plant: '',
      mobile_no: '',
    }
  });
  const locationType = watch("location_type");
  const userRole = watch("user_role_id");
  const navigate = useNavigate();
  const urlLocation = useLocation();
  const editData = urlLocation.state;
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;

  const [roles, setRoles] = useState([]);
  const [plant, setPlant] = useState([]);
  const [depot, setDepot] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);

  // Set form values for edit mode
  useEffect(() => {
    if (editData) {
      setValue("user_name", editData.user_name || '');
      setValue("user_role_id", editData.user_role || '');
      setValue("location_type", editData.plant_id ? 'Plant' : editData.depot_id ? 'Depot' : '');
      setValue("depot_id", editData.depot_id || '');
      setValue("plant", editData.plant_id || '');
      setValue("mobile_no", editData.mobile_no || '');
    }
  }, [editData, setValue]);

  // Fetch roles, plants, and depots
  useEffect(() => {
    async function fetchData() {
      try {
        const [plantData, depotData, roleData] = await Promise.all([
          plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
          depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
          userMasterService.getUserRoleList({ page: 0, size: 999, searchKey: "" }),
        ]);
        setPlant(plantData);
        setDepot(depotData);
        setRoles(roleData);
      } catch (error) {
        console.error("Data fetching failed", error);
      }
    }
    fetchData();
  }, []);

  const onSubmit = async (data) => {
  // Find the selected role object to get the user_role
  const selectedRole = roles.find((r) => r.user_role_id === data.user_role_id);
  
  const userData = {
    ...data,
    depot_name: depot.find((d) => d.depot_id === data.depot_id)?.depot_name || '',
    user_role: selectedRole ? selectedRole.user_role : '',
    modified_at: editData ? dayjs().format('YYYY-MM-DD HH:mm:ss') : null,
    modified_by: editData ? userInfo.user_id : null,
    created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    created_by: userInfo.user_id,
    changedUpdatedValue: editData ? 'edit' : 'add',
    full_name: data.user_name,
  };

  try {
    if (editData) {
      await userMasterService.editDeleteUser(userData);
      setSuccessMessage("Updated successfully");
    } else {
      await userMasterService.addUser(userData);
      setSuccessMessage("Added successfully");
    }
    setTimeout(() => navigate(-1), 1000);
  } catch (error) {
    setSuccessMessage("Error occurred");
  }
};
  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: 'User' }]} />
        <Box sx={{ display: "flex" }}>
          <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
            <Grid item md={7} sm={6} xs={12}>
              <Typography className={`${styles.header_txt}`}>
                {editData ? 'Update' : 'CREATE'} USER MASTER
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={0.6} className={`${styles.Grid_container}`}>
              <Grid item xs={12} sm={5}>
                <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" } }}>
                  <Typography className={`${styles.label_Txt}`}>
                    User Name <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Controller
                    name="user_name"
                    control={control}
                    rules={{ required: "User Name is required" }}
                    render={({ field }) => (
                      <CTSinput
                        {...field}
                        size="small"
                        fullWidth
                        type="text"
                        error={!!errors.user_name}
                        helperText={errors.user_name?.message}
                        InputProps={{ className: styles.CTSinput_Box }}
                      />
                    )}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={5}>
                <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" } }}>
                  <Typography className={`${styles.label_Txt}`}>
                    User Role <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Controller
                    name="user_role_id"
                    control={control}
                    rules={{ required: "User Role is required" }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={roles || []}
                        getOptionLabel={(option) => option.user_role || ""}
                        value={roles.find((r) => r.user_role_id === field.value) || null}
                        onChange={(_, newValue) => field.onChange(newValue ? newValue.user_role_id : '')}
                        renderOption={(props, option) => (
                          <MenuItem {...props} className={styles.cts_lable}>
                            {option.user_role}
                          </MenuItem>
                        )}
                        renderInput={(params) => (
                          <CTSinput
                            {...params}
                            size="small"
                            fullWidth
                            error={!!errors.user_role_id}
                            helperText={errors.user_role_id?.message}
                            InputProps={{ ...params.InputProps, className: styles.CTSinput_Box }}
                          />
                        )}
                        isOptionEqualToValue={(option, value) => option.user_role_id === value}
                      />
                    )}
                  />
                </Box>
              </Grid>

              {userRole !== 'Admin' ? (
                <Grid item xs={12} sm={5}>
                  <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" } }}>
                    <Typography className={`${styles.label_Txt}`}>
                      Location Type <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Controller
                      name="location_type"
                      control={control}
                      rules={{ required: "Location Type is required" }}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          options={['Plant', 'Depot']}
                          fullWidth
                          value={field.value || null}
                          onChange={(_, newValue) => {
                            field.onChange(newValue || '');
                            setValue("depot_id", '');
                            setValue("plant", '');
                          }}
                          renderInput={(params) => (
                            <CTSinput
                              {...params}
                              size="small"
                              fullWidth
                              error={!!errors.location_type}
                              helperText={errors.location_type?.message}
                              InputProps={{ ...params.InputProps, className: styles.CTSinput_Box }}
                            />
                          )}
                          isOptionEqualToValue={(option, value) => option === value}
                        />
                      )}
                    />
                  </Box>
                </Grid>
              ) : (
                <Grid item xs={12} sm={5}>
                  <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" } }}>
                    <Typography className={`${styles.label_Txt}`}>Location</Typography>
                    <Typography variant="body1" className={`${styles.cts_lable}`}>
                      All Depots and Plants (Admin Access)
                    </Typography>
                  </Box>
                </Grid>
              )}

              {locationType === 'Depot' && (
                <Grid item xs={12} sm={5}>
                  <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" } }}>
                    <Typography className={`${styles.label_Txt}`}>
                      Depot <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Controller
                      name="depot_id"
                      control={control}
                      rules={{ required: "Depot is required" }}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          options={depot || []}
                          getOptionLabel={(option) => option.depot_name || ""}
                          value={depot.find((d) => d.depot_id === field.value) || null}
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.depot_id : '');
                            setValue("plant", '');
                          }}
                          renderOption={(props, option) => (
                            <MenuItem {...props} className={styles.cts_lable}>
                              {option.depot_name}
                            </MenuItem>
                          )}
                          renderInput={(params) => (
                            <CTSinput
                              {...params}
                              size="small"
                              fullWidth
                              error={!!errors.depot_id}
                              helperText={errors.depot_id?.message}
                              InputProps={{ ...params.InputProps, className: styles.CTSinput_Box }}
                            />
                          )}
                          isOptionEqualToValue={(option, value) => option.depot_id === value}
                        />
                      )}
                    />
                  </Box>
                </Grid>
              )}

              {locationType === 'Plant' && (
                <Grid item xs={12} sm={5}>
                  <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" } }}>
                    <Typography className={`${styles.label_Txt}`}>
                      Plant <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Controller
                      name="plant"
                      control={control}
                      rules={{ required: "Plant is required" }}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          options={plant || []}
                          getOptionLabel={(option) => option.plant_name || ""}
                          value={plant.find((p) => p.plant_id === field.value) || null}
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.plant_id : '');
                            setValue("depot_id", '');
                          }}
                          renderOption={(props, option) => (
                            <MenuItem {...props} className={styles.cts_lable}>
                              {option.plant_name}
                            </MenuItem>
                          )}
                          renderInput={(params) => (
                            <CTSinput
                              {...params}
                              size="small"
                              fullWidth
                              error={!!errors.plant}
                              helperText={errors.plant?.message}
                              InputProps={{ ...params.InputProps, className: styles.CTSinput_Box }}
                            />
                          )}
                          isOptionEqualToValue={(option, value) => option.plant_id === value}
                        />
                      )}
                    />
                  </Box>
                </Grid>
              )}

              {['Depot', 'Plant', 'Driver'].includes(roles.find(r => r.user_role_id === userRole)?.user_role) && (
                <Grid item xs={12} sm={5}>
                  <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" } }}>
                    <Typography className={`${styles.label_Txt}`}>
                      Mobile No <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Controller
                      name="mobile_no"
                      control={control}
                      rules={{
                        required: "Mobile Number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Invalid mobile number (10 digits required)"
                        }
                      }}
                      render={({ field }) => (
                        <CTSinput
                          {...field}
                          size="small"
                          fullWidth
                          type="text"
                          error={!!errors.mobile_no}
                          helperText={errors.mobile_no?.message}
                          InputProps={{ className: styles.CTSinput_Box }}
                        />
                      )}
                    />
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} className={`${styles.grid_input}`}>
                <Box className={`${styles.btn_container}`}>
                  <Button
                    id={`${styles.btn_save}`}
                    type="submit"
                  >
                    <SaveIcon className={`${styles.btn_cancel_txt}`} />
                    <Typography className={`${styles.btn_cancel_txt}`}>
                      {editData ? "Update" : "Save"}
                    </Typography>
                  </Button>
                  <Cancel />
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage(null);
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default UserAdd;